
<i
  :class=" classes(n(), [$props.activated, n('--activated')], [$props.horizontal, n('--horizontal')], [$props.dashed, n('--dashed')])"
/>
